const KEY = 'post_login_redirect';

/** Remember a same-origin path (with search + hash) an unauthenticated visitor tried to open. */
export const rememberRequestedUrl = (location: {
  pathname: string;
  search: string;
  hash: string;
}) => {
  const { pathname, search, hash } = location;
  // '/'            -> the sign-in page itself; nothing to come back to (homepage sends users to /deals anyway).
  // no leading '/' -> not an app path; history.push would resolve it relative to the current URL.
  // '//'           -> open-redirect guard: '//evil.com/x' is a protocol-relative URL and would leave the site.
  if (pathname === '/' || !pathname.startsWith('/') || pathname.startsWith('//')) return;
  sessionStorage.setItem(KEY, `${pathname}${search}${hash}`);
};

/** Return the remembered path once, or null. */
export const consumeRequestedUrl = (): string | null => {
  const url = sessionStorage.getItem(KEY);
  if (url) sessionStorage.removeItem(KEY);
  return url;
};
